
import Vue from 'vue';
import { ModalTitle, Loading } from '@descomplica/vue-components';
import { LocaleMessage } from 'vue-i18n';

interface Data {
  currentMessageIndex: number;
  timer: ReturnType<typeof setTimeout> | null;
}

export default Vue.extend({
  components: {
    ModalTitle,
    Loading,
  },
  props: {
    messages: {
      type: Array as Vue.PropType<string[]>,
      required: true,
    },
    subtitle: {
      type: String,
      default: '',
    },
  },
  data(): Data {
    return {
      currentMessageIndex: 0,
      timer: null,
    };
  },
  computed: {
    currentMessage(): LocaleMessage {
      return this.messages[this.currentMessageIndex];
    },
  },
  created() {
    this.cycleMessages();
  },
  beforeDestroy() {
    if (this.timer) clearTimeout(this.timer);
  },
  methods: {
    cycleMessages() {
      this.timer = setTimeout(() => {
        if (this.currentMessageIndex < this.messages.length - 1) {
          this.currentMessageIndex += 1;
          setTimeout(this.cycleMessages);
        }
      }, 3000);
    },
  },
});
